import { createContext, useContext, useState } from "react";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
//services
import { postRetryPayment } from "../../../services/CreateAccount/postRetryPayment";
import { postActivationPlan } from "../../../services/CreateAccount/postActivationPlan";
import { getValidateCupom } from "../../../services/CreateAccount/getValidateCupom";
//context
const RegisterCompletedContext = createContext();

export function RegisterCompletedProvider({ children }) {
  const form = useForm();
  const formPix = useForm();
  const { state } = useLocation();
  const navigate = useNavigate();
  const [plan, setPlan] = useState(null);
  const [cupom, setCupom] = useState("");
  const [bestDay, setBestDay] = useState(null);
  const [pixClient, setPixClient] = useState(null);
  const [pixDataQR, setPixDataQR] = useState(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [optionsDays, setOptionsDays] = useState([]);
  const [sortedData, setSortedData] = useState(null);
  const [errorCupom, setErrorCupom] = useState(false);
  const [activePlan, setActivePlan] = useState(false);
  const [typeInterval, setTypeInterval] = useState(null);
  const [baseDataForm, setBaseDataForm] = useState(null);
  const [appliedCoupon, setAppliedCoupon] = useState(null);
  const [paymentMethod, setPaymentMethod] = useState(null);
  const [loadingButton, setLoadingButton] = useState(false);
  const [disabledButton, setDisabledButton] = useState(true);
  const [activeIndexModal, setActiveIndexModal] = useState(0);
  const [selectedInterval, setSelectedInterval] = useState(0);
  const [paymentId, setPaymentId] = useState(state?.idPayment);
  const [visibleIntervals, setVisibleIntervals] = useState(null);
  const [creditCardClient, setCreditCardClient] = useState(null);
  const [loadingIntervals, setLoadingIntervals] = useState(null);
  const [baseDataIntervals, setBaseDataIntervals] = useState(null);
  const [visibleCreditCard, setVisibleCreditCard] = useState(false);
  const [visiblePixPayment, setVisiblePixPayment] = useState(false);
  const [creditCardSelected, setCreditCardSelected] = useState(null);
  const [optionsInstallments, setOptionsInstallments] = useState([]);
  const [visiblePaymentModal, setVisiblePaymentModal] = useState(false);
  const [visiblePaymentMethods, setVisiblePaymentMethods] = useState(true);
  const [visibleActivationModal, setVisibleActivationModal] = useState(false);
  const [visibleModalCreditCard, setVisibleModalCreditCard] = useState(false);
  const [cardState, setCardState] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });
  const [cardInstallment, setCardInstallment] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });
  const [cardMonthly, setCardMonthly] = useState({
    card_number: "",
    expiry: "",
    cvc: "",
    name: "",
    focus: "",
  });
  const handleSelectPaymentMethod = (value) => {
    setVisiblePaymentMethods(false);
    setPaymentMethod(value);
  };

  const handleInputChange = (name, value) => {
    setCardState((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputFocus = (name) => {
    setCardState((prev) => ({ ...prev, focus: name }));
  };

  const handleInstallmentChange = (name, value) => {
    setCardInstallment((prev) => ({ ...prev, [name]: value }));
  };

  const handleInstallmentFocus = (name) => {
    setCardInstallment((prev) => ({ ...prev, focus: name }));
  };

  const handleMonthlyChange = (name, value) => {
    setCardMonthly((prev) => ({ ...prev, [name]: value }));
  };

  const handleMonthlyFocus = (name) => {
    setCardMonthly((prev) => ({ ...prev, focus: name }));
  };

  const onSubmitPix = (data) => {
    setPixClient(data);
    setVisiblePaymentMethods(true);
    form.setValue("installments", null);
  };

  const validateCupom = async (cupom, setLoading) => {
      //    console.log(cupom);
      setLoading(true);
      // const notification = toast.loading("Por favor aguarde...");
      try {
        const response = await getValidateCupom(cupom, typeInterval.id);
        if (response.cupom !== false) {
          setAppliedCoupon(response.cupom);
          form.clearErrors("cupom");
          setErrorCupom(false);
        } else {
          form.setError("cupom");
          setErrorCupom(true);
        }
      } catch (e) {
        form.setError("cupom");
        setErrorCupom(true);
      }
      setLoading(false);
    };

  const handleSubmit = async () => {
    //    console.log(plan);
    //    console.log(contract);
    //    console.log(cardState);
    //    console.log(pixClient);
    //    console.log(cardMonthly);
    //    console.log(baseDataForm);
    //    console.log(cardInstallment);
    //    console.log(creditCardClient);
    //    console.log(form.getValues());

    setLoadingButton(true);

    const isValidCPF = (doc) => {
      const cleanedDoc = doc.replace(/\D/g, "");
      return cleanedDoc.length === 11;
    };

    const isValidCNPJ = (doc) => {
      const cleanedDoc = doc.replace(/\D/g, "");
      return cleanedDoc.length === 14;
    };

    const getDocType = (doc) => {
      if (isValidCPF(doc)) return 1;
      if (isValidCNPJ(doc)) return 2;
      return null;
    };

    const isFormIncomplete = (formData) => {
      return Object.values(formData).some(
        (value) => value === null || value === ""
      );
    };

    const isCardStateEmpty = Object.values(cardState).every(
      (value) => value === ""
    );
    const isPixClientNull = pixClient === null;
    // const isCardMonthlyEmpty = Object.values(cardMonthly).every(
    //   (value) => value === ""
    // );

    if (isCardStateEmpty && isPixClientNull) {
      toast.warning("Por favor, adicione os dados para pagamento!");
      setLoadingButton(false);
      return;
    }

    if (!plan) {
      toast.warning("Por favor, selecione um plano!");
      setLoadingButton(false);
      setActiveIndex(2);
      return;
    }

    // const notification = toast.loading("Por favor aguarde...");
    setLoadingButton(true);
    const [exp_month, exp_year] = cardMonthly.expiry.split("/");

    const obj = {
      plan_id: plan.plan.id,
      interval_id: plan.interval.id,
      users: baseDataForm.doc.map((doc, index) => {
        const user = {
          doc: doc,
          name: baseDataForm.name[index],
          email: baseDataForm.email[index],
        };
        return user;
      }),
    };

    if (appliedCoupon) {
      obj.cupom = appliedCoupon.name;
    }

    if (bestDay) {
      obj.invoice_due_date = bestDay;
    }

    if (typeInterval.type === "month") {
      if (paymentMethod === "card" || paymentMethod === "installment") {
        obj.payment_subscription_fee = {
          payment_method: "credit_card",
          installments: form.getValues().installments
            ? form.getValues().installments
            : 1,
          holder_name: cardMonthly.name,
          card_number: cardMonthly.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvv: cardMonthly.cvc,
          ...creditCardClient.data,
          billing_address: {
            ...creditCardClient.address,
          },
        };

        // obj.payment_month = {
        //   payment_method: "credit_card",
        //   holder_name: cardMonthly.name,
        //   card_number: cardMonthly.card_number,
        //   exp_month: exp_month,
        //   exp_year: exp_year,
        //   cvv: cardMonthly.cvc,
        //   ...creditCardClient.data,
        //   billing_address: {
        //     ...creditCardClient.address,
        //   },
        // };
      }

      if (paymentMethod === "pix") {
        obj.payment_subscription_fee = {
          payment_method: "pix",
          customer_name: pixClient.customer_name,
          customer_email: pixClient.customer_email,
          customer_doc: pixClient.customer_doc,
          customer_phone: pixClient.phone_pix,
        };

        // obj.payment_month = {
        //   payment_method: "credit_card",
        //   holder_name: cardMonthly.name,
        //   card_number: cardMonthly.card_number,
        //   exp_month: exp_month,
        //   exp_year: exp_year,
        //   cvv: cardMonthly.cvc,
        //   ...creditCardClient.data,
        //   billing_address: {
        //     ...creditCardClient.address,
        //   },
        // };
      }
    }

    if (typeInterval.type === "year") {
      if (paymentMethod === "card" || paymentMethod === "installment") {
        obj.payment = {
          payment_method: "credit_card",
          installments: form.getValues().installments
            ? form.getValues().installments
            : 1,
          holder_name: cardMonthly.name,
          card_number: cardMonthly.card_number,
          exp_month: exp_month,
          exp_year: exp_year,
          cvv: cardMonthly.cvc,
          ...creditCardClient.data,
          billing_address: {
            ...creditCardClient.address,
          },
        };
      }

      if (paymentMethod === "pix") {
        if (
          pixClient.phone_pix &&
          pixClient.customer_name &&
          pixClient.customer_email &&
          pixClient.customer_doc
        ) {
          obj.payment = {
            payment_method: "pix",
            customer_name: pixClient.customer_name,
            customer_email: pixClient.customer_email,
            customer_doc: pixClient.customer_doc,
            customer_phone: pixClient.phone_pix,
          };
        } else {
          toast.warning("Preencha todos os campos!");
          setLoadingButton(false);
          return;
        }
      }
    }

    // console.log("Obj Final: ", obj);

    try {
      const response = await postActivationPlan(obj);
      // console.log(response);
      //Lógica para receber o response e abrir o QRCode do PIX
      if (response.code) {
        toast.error(
          "Ocorreu um erro ao enviar os dados, verifique seus dados de pagamento"
        );
        // toast.update(notification, {
        //   render: "Ocorreu um erro ao enviar os dados",
        //   autoClose: 5000,
        //   type: "error",
        //   isLoading: false,
        // });
        navigate("/");
        setLoadingButton(false);
        return;
      }

      if (response.success.link_QRcode) {
        setLoadingButton(false);
        setPixDataQR({
          id: response.success.payment_id,
          copy: response.success.pix,
          qr_code: response.success.link_QRcode,
          timer: 7,
        });
        setActivePlan(true);
        setVisiblePixPayment(true);
        return;
      }

      if (response.success.payment_id) {
        // toast.update(notification, {
        //   render: "Cadastro efeituado com sucesso",
        //   autoClose: 5000,
        //   type: "success",
        //   isLoading: false,
        // });
        toast.success("Conta efetivada com sucesso");
        setLoadingButton(false);
        setVisibleActivationModal(false);
        setActivePlan(true);
        setPaymentId(response.success.payment_id);
        return;
      }

      // console.log(response);
      // toast.success("Conta ativa com sucesso");
      // toast.update(notification, {
      //   render: "Cadastro efeituado com sucesso",
      //   autoClose: 5000,
      //   type: "success",
      //   isLoading: false,
      // });
      setLoadingButton(false);
      // navigate(`/success`, {
      //   state: { email: obj.email },
      // });
      // navigate(`/`);
    } catch (error) {
      setLoadingButton(false);
      toast.error("Ocorreu um erro ao enviar os dados, verifique seus dados de pagamento");
      // toast.update(notification, {
      //   render: error.response.data?.errors?.doc
      //     ? "Documento Inválido, adicione um CPF ou CNPJ válido"
      //     : "Ocorreu um erro ao enviar os dados",
      //   autoClose: 5000,
      //   type: "error",
      //   isLoading: false,
      // });
    }
    setLoadingButton(false);
  };

  const handleRetryPaymentYear = async () => {
    setLoadingButton(true);
    // console.log(cardState);
    // console.log(pixClient);
    // console.log(baseDataForm);
    // console.log(cardInstallment);
    // console.log(creditCardClient);
    // console.log(form.getValues());
    let obj = {};

    if (paymentMethod === "card") {
      const [exp_month, exp_year] = cardState.expiry.split("/");
      obj.payment = {
        payment_method: "credit_card",
        installments: form.getValues().installments
          ? form.getValues().installments
          : 1,
        holder_name: cardState.name,
        card_number: cardState.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvv: cardState.cvc,
        ...creditCardClient.data,
        billing_address: {
          ...creditCardClient.address,
        },
      };
    }

    if (paymentMethod === "installment") {
      const [exp_month, exp_year] = cardInstallment.expiry.split("/");
      obj.payment = {
        payment_method: "credit_card",
        installments: form.getValues().installments
          ? form.getValues().installments
          : 1,
        holder_name: cardInstallment.name,
        card_number: cardInstallment.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvv: cardInstallment.cvc,
        ...creditCardClient.data,
        billing_address: {
          ...creditCardClient.address,
        },
      };
    }

    if (paymentMethod === "pix") {
      if (
        pixClient.phone_pix &&
        pixClient.customer_name &&
        pixClient.customer_email &&
        pixClient.customer_doc
      ) {
        obj.payment = {
          payment_method: "pix",
          customer_name: pixClient.customer_name,
          customer_email: pixClient.customer_email,
          customer_doc: pixClient.customer_doc,
          customer_phone: pixClient.phone_pix,
        };
      } else {
        toast.warning("Preencha todos os campos!");
        setLoadingButton(false);
        return;
      }
    }
    // console.log(obj);

    try {
      const response = await postRetryPayment(
        obj,
        state?.idPayment ? state?.idPayment : ""
      );
      // console.log(response);

      if (response.code) {
        // navigate("/");
        if (response.code === "400") {
          toast.danger("Número do cartão inválido");
        }
        setLoadingButton(false);
        return;
      }

      if (response.success.link_QRcode) {
        setPixDataQR({
          id: response.success.payment_id,
          copy: response.success.pix,
          qr_code: response.success.link_QRcode,
          timer: 7,
        });
        setVisiblePixPayment(true);
        setLoadingButton(false);
        return;
      }

      if (response.success) {
        setVisiblePaymentModal(false);
        setLoadingButton(false);
        navigate(`/success`, {
          state: { idPayment: response.success.payment_id },
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }
    setLoadingButton(false);
  };

  const handleRetryPaymentMonth = async () => {
    setLoadingButton(true);
    // console.log(cardState);
    // console.log(pixClient);
    // console.log(cardMonthly);
    // console.log(baseDataForm);
    // console.log(cardInstallment);
    // console.log(creditCardClient);
    // console.log(form.getValues());
    let obj = {};

    if (paymentMethod === "card") {
      const [exp_month, exp_year] = cardState.expiry.split("/");
      obj.payment_subscription_fee = {
        payment_method: "credit_card",
        installments: form.getValues().installments
          ? form.getValues().installments
          : 1,
        holder_name: cardState.name,
        card_number: cardState.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvv: cardState.cvc,
        ...creditCardClient.data,
        billing_address: {
          ...creditCardClient.address,
        },
      };
    }

    if (paymentMethod === "installment") {
      const [exp_month, exp_year] = cardInstallment.expiry.split("/");
      obj.payment_subscription_fee = {
        payment_method: "credit_card",
        installments: form.getValues().installments
          ? form.getValues().installments
          : 1,
        holder_name: cardInstallment.name,
        card_number: cardInstallment.card_number,
        exp_month: exp_month,
        exp_year: exp_year,
        cvv: cardInstallment.cvc,
        ...creditCardClient.data,
        billing_address: {
          ...creditCardClient.address,
        },
      };
    }

    if (paymentMethod === "pix") {
      if (
        pixClient.phone_pix &&
        pixClient.customer_name &&
        pixClient.customer_email &&
        pixClient.customer_doc
      ) {
        obj.payment_subscription_fee = {
          payment_method: "pix",
          customer_name: pixClient.customer_name,
          customer_email: pixClient.customer_email,
          customer_doc: pixClient.customer_doc,
          customer_phone: pixClient.phone_pix,
        };
      } else {
        toast.warning("Preencha todos os campos!");
        setLoadingButton(false);
        return;
      }
    }

    // const [exp_month, exp_year] = cardMonthly.expiry.split("/");

    // obj.payment_month = {
    //   payment_method: "credit_card",
    //   holder_name: cardMonthly.name,
    //   card_number: cardMonthly.card_number,
    //   exp_month: exp_month,
    //   exp_year: exp_year,
    //   cvv: cardMonthly.cvc,
    //   ...creditCardClient.data,
    //   billing_address: {
    //     ...creditCardClient.address,
    //   },
    // };

    // console.log(obj);

    try {
      const response = await postRetryPayment(
        obj,
        state?.idPayment ? state?.idPayment : ""
      );
      // console.log(response);

      if (response.status) {
        // navigate("/");
        if (response.status === "400") {
          toast.danger("Número do cartão inválido");
        }
        setLoadingButton(false);
        return;
      }

      if (response.success.link_QRcode) {
        setPixDataQR({
          id: response.success.payment_id,
          copy: response.success.pix,
          qr_code: response.success.link_QRcode,
          timer: 7,
        });
        setVisiblePixPayment(true);
        setLoadingButton(false);
        return;
      }

      if (response.success) {
        setVisiblePaymentModal(false);
        setLoadingButton(false);
        navigate(`/success`, {
          state: { idPayment: response.success.payment_id },
        });
        return;
      }
    } catch (error) {
      console.log(error);
    }
    setLoadingButton(false);
  };

  return (
    <RegisterCompletedContext.Provider
      value={{
        form,
        plan,
        cupom,
        bestDay,
        setPlan,
        formPix,
        setCupom,
        paymentId,
        cardState,
        pixClient,
        pixDataQR,
        activePlan,
        errorCupom,
        setBestDay,
        sortedData,
        onSubmitPix,
        optionsDays,
        cardMonthly,
        activeIndex,
        baseDataForm,
        setPaymentId,
        setCardState,
        setPixClient,
        setPixDataQR,
        handleSubmit,
        typeInterval,
        setErrorCupom,
        setActivePlan,
        appliedCoupon,
        validateCupom,
        setSortedData,
        loadingButton,
        paymentMethod,
        disabledButton,
        setActiveIndex,
        setCardMonthly,
        setOptionsDays,
        setBaseDataForm,
        cardInstallment,
        setTypeInterval,
        selectedInterval,
        setAppliedCoupon,
        setLoadingButton,
        activeIndexModal,
        loadingIntervals,
        creditCardClient,
        handleInputFocus,
        setPaymentMethod,
        visibleIntervals,
        setDisabledButton,
        visiblePixPayment,
        visibleCreditCard,
        baseDataIntervals,
        handleInputChange,
        creditCardSelected,
        setCardInstallment,
        handleMonthlyFocus,
        setSelectedInterval,
        handleMonthlyChange,
        optionsInstallments,
        setActiveIndexModal,
        visiblePaymentModal,
        setCreditCardClient,
        setLoadingIntervals,
        setVisibleIntervals,
        setVisibleCreditCard,
        setVisiblePixPayment,
        setBaseDataIntervals,
        visiblePaymentMethods,
        setCreditCardSelected,
        visibleModalCreditCard,
        setVisiblePaymentModal,
        visibleActivationModal,
        handleInstallmentFocus,
        setOptionsInstallments,
        handleRetryPaymentYear,
        handleInstallmentChange,
        handleRetryPaymentMonth,
        setVisiblePaymentMethods,
        handleSelectPaymentMethod,
        setVisibleActivationModal,
        setVisibleModalCreditCard,
      }}
    >
      {children}
    </RegisterCompletedContext.Provider>
  );
}

export function useRegisterCompletedContext() {
  return useContext(RegisterCompletedContext);
}
